<template>
  <div>
    <label class="typo__label">{{ season_options.label }}</label>
    <multiselect
      v-model="seasonsSelected"
      select-label=""
      deselect-label=""
      track-by="id"
      label="text"
      placeholder="Select at least one"
      :options="season_options.data"
      :close-on-select="false"
      :searchable="false"
      :allow-empty="false"
      :preselect-first="true"
      :multiple="true"
      @input="inputFunc">
      <template slot="tag" slot-scope="props"><span class="custom__tag"><span>{{ props.option.text }}</span><span class="custom__remove" @click="props.remove(props.option)">❌</span></span></template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'SeasonSelect',
  components: {
    Multiselect
  },
  props: ['value', 'options', 'inputFunc'],
  data () {
    return {
      season_options: this.options,
      seasons_selected: this.value
    }
  },
  computed: {
    seasonsSelected: {
      get () {
        return this.seasons_selected
      },
      set (value) {
        this.seasons_selected = value
        this.$emit('input', value)
      }
    }
  },
  watch: {
    options: function (val) {
      this.season_options = val
      this.setSeasonsSelected()
      if (this.seasons_selected.length === 0) {
        this.seasons_selected.push(val.data[0])
      }
    }
  },
  methods: {
    getSeasonsSelectedString () {
      var seasonSelectedString = ''
      for (var i = 0; i < this.seasons_selected.length; i++) {
        if (i === 0) {
          seasonSelectedString += this.seasons_selected[i].id
        } else {
          seasonSelectedString += ',' + this.seasons_selected[i].id
        }
      }
      return seasonSelectedString
    },
    setSeasonsSelected () {
      this.seasons_selected = []
      if (this.$route.query.Season && this.season_dropdown.data) {
        this.season_dropdown.data.forEach((seasonOption) => {
          this.$route.query.Season.split(',').forEach((seasonSelected) => {
            if (seasonOption.id === seasonSelected) {
              this.seasons_selected.push(seasonOption)
            }
          })
        })
      }
    },
    setSeasonDropdown () {
      this.season_dropdown = this.getSeasonDropdownForLeague(this.$route.params.league)
      if (this.$route.query.Season) {
        this.setSeasonsSelected()
      }

      // this happens on league change  - set to first option
      if (this.seasons_selected.length === 0) {
        this.seasons_selected.push(this.season_dropdown.data[0])
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mixins/SeasonSelect.vue